import _ from 'lodash'
import { carportActions } from '../../Redux';
const updateInputInStore = (dispatch, key, changed_value) => {
	dispatch(carportActions.updateInputByName(key, changed_value));
}
export const debouncedUpdateinput = _.debounce(updateInputInStore, 1000);
